import React, { useEffect } from 'react';
import ProfileForm from './ProfileForm';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import qs from 'qs';
import {
  authorizeStripeOAuth,
  verifyStripeOnboarding,
  refreshStripeAccountLink,
  getInitialInfo,
} from '../../../actions';
import { notification } from 'antd';

export default function Profile() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const parameters = qs.parse(location.search, { ignoreQueryPrefix: true });

  useEffect(() => {
    if (parameters.success === 'true') {
      notification.success({
        message: 'Verifying Your Account',
        description: 'Please wait while we verify your Stripe connection...',
        duration: 3,
      });
      dispatch(verifyStripeOnboarding());

      navigate('/my-account/edit-profile', { replace: true });
    } else if (parameters.refresh === 'true') {
      notification.info({
        message: 'Session Expired',
        description:
          'Your onboarding session expired. Generating a new link...',
        duration: 3,
      });
      dispatch(refreshStripeAccountLink());

      navigate('/my-account/edit-profile', { replace: true });
    } else if (parameters.code && parameters.state) {
      dispatch(authorizeStripeOAuth(parameters.code, parameters.state));

      navigate('/my-account/edit-profile', { replace: true });
    }
  }, [dispatch, navigate, parameters]);

  useEffect(() => {
    dispatch(getInitialInfo());
  }, [dispatch]);

  return (
    <section className="Profile">
      <ProfileForm />
    </section>
  );
}
